/**
 * Returns true if the app is being run from the Manheim Mobile App. Is based off the cookie: manheim_mobile_application_flag
 */
export const isMobile = () => {
  const platform = getCookie('manheim_mobile_application_flag');
  return platform !== '' && platform !== undefined;
};

/**
 * Returns the value of the passed in cookie or undefined if it doesn't exist
 */
export const getCookie = (name: string): string | undefined => {
  // eslint-disable-next-line no-restricted-properties
  const parts = `; ${document.cookie}`.split(`; ${name}=`);
  return parts.length === 2 ? parts.slice(-1)[0]?.split(';')[0] : undefined;
};
